import { render } from "./ProductList.vue?vue&type=template&id=2c8a7e7e&ts=true"
import script from "./ProductList.vue?vue&type=script&lang=ts"
export * from "./ProductList.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__